export default "/_next/static/chunks/fonts/WhitneySSm-BookItalic-Pro_Web-1cd986b8caef99ab8f122bb08bf430d4.woff";